import axios from './axios-instance'

export default {
  getStrengthTest (id) {
    return axios.get(`v1/strength_tests/student/${id}`)
  }
}
